<template>
  <div class="h-full overflow-hidden flex flex-col pt-3">
    <el-table
      :data="state.list_data"
      v-loading="!Array.isArray(state.list_data)"
      element-loading-background="rgba(0, 0, 0, 0.2)"
      ref="tableDom"
    >
      <el-table-column
        fixed
        label="#"
        width="70"
        type="index"
        :index="
          (index) =>
            $buildTabIndex(state.params.page, state.params.limit, index)
        "
        align="center"
      />
      <el-table-column :width="180">
        <template #header>
          <el-tooltip
            content="当步骤状态为待审批状态时，操作人为待操作的人员；反之操作人为已操作的人员"
          >
            <div class="flex items-center gap-x-1 cursor-pointer">
              <div
                class="c-table-col-header"
                label1="当前步骤"
                label2="操作人时间"
              />
              <el-icon><QuestionFilled /></el-icon>
            </div>
          </el-tooltip>
        </template>
        <template #default="{ row }">
          <c_tabgroup>
            <template #top>
              <ul class="flex gap-x-1 items-center">
                <text>
                  {{ row.flowApproveStep?.step_name }}
                </text>
                <c_status
                  arrName="Common_Check_Status"
                  :value="row.flowApproveStep?.status"
                  :key="row.flowApproveStep?.status"
                />
              </ul>
            </template>
            <template #bottom>
              <ul class="flex gap-x-1 items-baseline">
                <text class="text-gray-600">
                  {{ row.flowApproveStep?.approve_admin_name }}
                </text>
                <text class="ml-1">
                  {{ row.flowApproveStep?.approve_department_name }}
                </text>
              </ul>
              <ul class="flex gap-x-1 items-center">
                <text v-if="row?.flowApproveStep?.approve_time">
                  {{ row.flowApproveStep?.approve_time }}
                </text>
              </ul>
            </template>
          </c_tabgroup>
        </template>
      </el-table-column>
      <el-table-column :width="300">
        <template #header>
          <div class="c-table-col-header" label1="付款单号" label2="收款信息" />
        </template>
        <template #default="{ row }">
          <c_tabgroup>
            <template #top>
              <div
                class="flex items-center gap-x-2 text-green-700 cursor-pointer hover:underline"
              >
                <strong>{{ row.number }}</strong>
              </div>
            </template>
            <template #bottom>
              <text v-if="row.is_supplier_purchase">
                {{
                  [
                    row.supplierBankAccount?.opening_bank,
                    row.supplierBankAccount?.name,
                    row.supplierBankAccount?.account,
                  ]
                    .filter((w) => w)
                    .join("-")
                }}
              </text>
              <text v-else>
                {{
                  [row.opening_bank, row.bank_account_name, row.bank_account]
                    .filter((w) => w)
                    .join("-")
                }}
              </text>
            </template>
          </c_tabgroup>
        </template>
      </el-table-column>
      <el-table-column :width="300">
        <template #header>
          <div class="c-table-col-header" label1="会议名称" label2="会议时间" />
        </template>
        <template #default="{ row }">
          <c_tabgroup
            :value2="row.meeting?.start_date + ' ~ ' + row.meeting?.end_date"
          >
            <template #top>
              <div
                class="flex items-center gap-x-2 text-green-700 cursor-pointer hover:underline"
                @click="
                  $openMenu({
                    path: 'HuiYiDetail',
                    title: '会议详情-' + row.meeting?.name,
                    refresh: true,
                    data: {
                      id: row.meeting?.id,
                    },
                  })
                "
              >
                <strong>
                  {{ row.meeting?.name + "[" + row.meeting?.number + "]" }}
                </strong>
              </div>
            </template>
          </c_tabgroup>
        </template>
      </el-table-column>
      <el-table-column :width="140">
        <template #header>
          <div class="c-table-col-header" label1="金额" label2="付款方式" />
        </template>
        <template #default="{ row }">
          <div class="flex gap-x-1">
            <c_money :value="row.amount" bold :prefix="false" />
            <text class="text-xs text-gray-400">
              {{ row.d_payment_type_name }}
            </text>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="intro"
        label="申请说明"
        :formatter="$tab_TextFormat"
        :min-width="160"
      />
      <el-table-column
        label="附件"
        prop="remark"
        :formatter="$tab_TextFormat"
        :width="500"
      >
        <template #default="{ row }">
          <div
            class="flex flex-wrap gap-x-5 gap-y-2"
            v-if="row.attachment?.length > 0"
          >
            <text
              v-for="file in row.attachment"
              :key="item"
              class="hover:underline cursor-pointer text-green-700"
              @click="$openFile(file.file_url)"
            >
              {{ file.filename }}
            </text>
          </div>
          <text v-else>-</text>
        </template>
      </el-table-column>
      <el-table-column label="申请人" :width="160">
        <template #default="{ row }">
          <c_tabgroup>
            <template #top>
              <text>{{ row?.add_admin_name }}</text>
              <text class="text-gray-400 text-xs ml-1">{{
                row?.add_department_name
              }}</text>
            </template>
            <template #bottom>
              <text>{{ row?.create_time }}</text>
            </template>
          </c_tabgroup>
        </template>
      </el-table-column>
      <el-table-column label="操作" fixed="right" align="center" :width="120">
        <template #default="{ row }">
          <el-button
            type="primary"
            :icon="Select"
            link
            @click.stop="
              state.selectId = row.id;
              state.showDetail = true;
            "
            v-if="row.status === 0"
            >审批
          </el-button>
          <el-button
            type="success"
            :icon="Search"
            link
            @click.stop="
              state.selectId = row.id;
              state.showDetail = true;
            "
            v-else
            >查看
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <c_page
      :total="state.totalCount"
      :pageIndex="state.params.page"
      :pageSize="state.params.limit"
      @onLoad="
        (page) => {
          state.params.page = page.pageIndex;
          state.params.limit = page.pageSize;
          onLoad();
        }
      "
    />
  </div>
  <el-dialog
    v-model="state.showDetail"
    title="采购付款审批"
    class="c-el-dialog"
    :before-close="
      () => {
        state.showDetail = false;
      }
    "
    style="width: 90%"
  >
    <c_detail
      :id="state.selectId"
      @close="
        state.showDetail = false;
        onLoad();
      "
    />
  </el-dialog>
</template>

<script>
import { onMounted, reactive } from "vue";
import { meetingpurchasepaymentapply_page } from "@/http/fukuanshenpi";

import c_detail from "./CaiGouShenPiDetail.vue";

class InitFormData {
  params = {
    page: 1,
  };
}

export default {
  components: {
    c_detail,
  },
  props: {
    params: Number,
  },
  setup(props) {
    const state = reactive({
      ...new InitFormData(),
    });
    onMounted(() => {
      state.params.is_approve = props.params?.is_approve;
      state.params.keywords = props.params?.keywords;
      onLoad();
    });

    const onLoad = () => {
      delete state.list_data;

      meetingpurchasepaymentapply_page(state.params).then((res) => {
        if (res.status == 200) {
          const { list, count } = res.data?.data;
          state.list_data = list;
          state.totalCount = count;
        }
      });
    };

    return { state, props, onLoad };
  },
};
</script>

<style lang="less" scoped></style>
